import { IChatV2ContentItem } from './ai-executor.interface';

// Should be updated on ai-gateway side if any changes are made to ensure type consistency
export interface IBaseContext {
  page: {
    url?: string;
    title?: string;
  };
  timezone?: string;
  digitalPropertyId?: string;
  workspaceId?: string;
}

export interface IContext {
  base?: IBaseContext;
  [key: string]: any; // Allow any other context fields
}

export interface IAiChatRequest {
  sessionId: string;
}

export interface ISendChatMessageRequest extends IAiChatRequest {
  message: string;
  context?: IContext;
  requestId?: string;
}

export interface ISetChatMessageRatingRequest extends IAiChatRequest {
  rating: number;
}

export const AI_CHAT_SESSION_TITLE_MAX_LENGTH = 100;
export const MAX_PINNED_CHAT_SESSIONS = 10;

export interface IUpdateChatSessionRequest {
  title: string;
}

export interface IFavoriteChatSessionRequest {
  isFavorite: boolean;
}

export enum IChatMessageStatus {
  pending = 'pending',
  processing = 'processing',
  done = 'done',
  error = 'error',
}

export interface ISendChatMessageResponse {
  _id: string;
  message: string;
  userId: string;
  sessionId?: string;
  status: IChatMessageStatus;
  response?: string; // holds pre-generative UI responses
  contentBlocks?: IChatV2ContentItem[];
  createdAt: string;
  startedAt?: string;
  endedAt?: string;
  error?: string;
  rating?: number;
}

export interface IChatSampleQuestion {
  key: string;
}

export interface IChatSession {
  sessionId: string;
  title?: string;
  titleTruncated?: boolean;
  firstActivity: string;
  lastActivity: string;
  isFavorite?: boolean;
  favoritedAt?: string;
}

export interface IChatSessionPage {
  sessions: IChatSession[];
  total: number;
}
